import { getFileReader, errorIfNoFileReader } from 'utils/wrappers';
import { showError } from 'utils/messages';
import { truncate } from 'utils/strings';

import Base from 'app/views/base';
import RemovePropertyButtonView from 'app/components/pages/brand/remove_property';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'change input.read-image': 'readImage',
  },

  initialize({ modelProperty, removeText, minWidth }) {
    this.modelProperty = modelProperty;
    this.minWidth = minWidth;
    this.removeText = removeText;
    this.listenTo(this.model, 'change', this.render);
    this.filename = undefined;
    if (this.removeText) {
      this.addSubview('resetImage', '.reset-image', new RemovePropertyButtonView({
        model: this.model, property: this.modelProperty, text: this.removeText,
      }));
    }
  },

  context() {
    return {
      filename: truncate(this.filename, 55),
    };
  },

  readImage({ target }) {
    const input = target;

    errorIfNoFileReader(input);

    const file = input.files[0];
    this.readFile(file, (image, result) => {
      if (!this.verifyWidth(image.width)) {
        showError(`Image width must be at least ${this.minWidth}px.`);
        return;
      }

      this.model.set(this.modelProperty, result);
    });
  },

  readFile(file, cb) {
    const reader = getFileReader();
    reader.onload = this.getImageFromReader(file.name, reader, cb);
    reader.readAsDataURL(file);
  },

  getImageFromReader(fileName, reader, cb) {
    return e => {
      this.filename = fileName;
      const image = new window.Image();
      image.src = e.target.result;
      image.onload = () => {
        cb(image, reader.result);
      };
    };
  },

  verifyWidth(imageWidth) {
    return this.minWidth ? Boolean(imageWidth >= this.minWidth) : true;
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/image_upload/index.js